var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('trax-ui-card',{attrs:{"title":"Deferred items"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.goals))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }